module.exports = __webpack_public_path__ + "img/PT5430.57f6af7d.png";